var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 62,
    viewBox: "0 0 139 62",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.974%",
    y1: "-2.056%",
    x2: "54.877%",
    y2: "100.048%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#254AA5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    opacity: 0.874,
    width: 139,
    height: 62,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.616 14.286c-.037-2.925 2.606-4.557 4.597-5.528 2.046-.996 2.733-1.634 2.725-2.525-.016-1.363-1.632-1.964-3.145-1.988-2.639-.04-4.173.713-5.393 1.283l-.95-4.45C32.674.514 34.94.02 37.29 0c5.516 0 9.125 2.724 9.144 6.948.022 5.36-7.411 5.657-7.36 8.053.017.727.71 1.502 2.229 1.699.751.1 2.826.176 5.178-.908l.923 4.306c-1.265.46-2.89.902-4.915.902-5.191 0-8.843-2.761-8.873-6.714m22.66 6.343a2.394 2.394 0 0 1-2.236-1.49L46.16.316h5.513L52.77 3.35h6.736l.636-3.033H65L60.76 20.63h-4.485m.771-5.487 1.591-7.628h-4.356l2.765 7.628m-30.113 5.487L22.59.316h5.252l4.343 20.313h-5.25m-7.77 0L13.695 6.803 11.485 18.56c-.26 1.312-1.285 2.07-2.423 2.07H.125L0 20.039c1.835-.398 3.92-1.04 5.182-1.728.773-.42.994-.787 1.247-1.785L10.618.316h5.551l8.51 20.313h-5.516",
    transform: "matrix(1 0 0 -1 35 41)",
    fill: "url(#a)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.02358372.svg";
export { ForwardRef as ReactComponent };